/**
 * deriveChoiceValue  (DA-2184)
 *
 * The choice `value` is no longer authored by hand — the BE derives it from the choice's
 * Display Text by stripping every non-alphanumeric character (then de-duplicating across the
 * question's choices, authoritatively, on save). We mirror the SAME base slug here so the
 * choice keeps a populated local `value` for identity / localization keying / diffing between
 * edits; the FE deliberately does NOT de-dup — the BE owns that.
 *
 * The regex MUST stay identical to the BE's (`[^a-zA-Z0-9]`) so EN and its localized rows,
 * which all derive from the same default-locale title, share one value.
 */
export function deriveChoiceValue(title: string): string {
  return String(title ?? '').replace(/[^a-zA-Z0-9]/g, '')
}
